// 이용약관·개인정보 처리방침 — 초안(placeholder) 텍스트.
// ⚠ 법적 검토가 필요합니다. 실제 서비스 오픈 전 운영자(또는 법률 자문)의 검토·수정을 거쳐야 합니다.

export const TERMS_TEXT = `제1조(목적)
이 약관은 ALIGN(이하 "회사")이 제공하는 사주명리·서양점성·베딕점성·자미두수·숙요점성 등 운세 콘텐츠 서비스(이하 "서비스")의 이용조건 및 절차에 관한 사항을 규정합니다.

제2조(서비스의 성격)
서비스가 제공하는 모든 콘텐츠는 오락 및 참고 목적으로 제공되며, 의학적·법률적·재정적 조언을 대체하지 않습니다. 서비스 이용에 따른 판단과 책임은 이용자 본인에게 있습니다.

제3조(회원가입)
이용자는 전화번호 또는 구글 계정으로 가입할 수 있으며, 정확한 정보를 입력할 책임이 있습니다. 허위 정보 기재로 발생하는 불이익은 이용자 본인이 부담합니다.

제4조(회사의 의무)
회사는 안정적인 서비스 제공을 위해 노력하며, 시스템 점검 등 불가피한 사유로 서비스를 일시 중단할 수 있습니다.

제5조(계정 관리)
이용자는 자신의 계정 정보를 안전하게 관리할 책임이 있습니다. 전화번호/비밀번호 가입 시 비밀번호 분실에 대한 재설정 절차가 제한적일 수 있으니 유의하시기 바랍니다.

제6조(약관의 변경)
회사는 필요 시 관련 법령을 위배하지 않는 범위에서 이 약관을 개정할 수 있으며, 개정 시 서비스 내 공지사항을 통해 안내합니다.`;

export const PRIVACY_TEXT = `1. 수집 항목
이름, 생년월일·생시, 출생지(좌표), 전화번호(또는 구글 계정 이메일·식별자)

2. 수집 목적
사주·점성 등 운세 콘텐츠 계산 및 개인화된 해석 제공, 회원 식별 및 로그인, 서비스 관련 안내

3. 보유 기간
회원 탈퇴 시까지 보관하며, 탈퇴 즉시 파기합니다.

4. 제3자 제공
원칙적으로 이용자의 개인정보를 외부에 제공하지 않습니다.

5. 이용자 권리
이용자는 언제든 자신의 개인정보 열람·정정·삭제를 요청할 수 있습니다.`;

export const MARKETING_TEXT = `신규 기능, 이벤트, 맞춤 운세 알림 등의 정보를 앱 내 알림 또는 푸시로 받아보실 수 있습니다. 동의하지 않아도 서비스 이용에는 제한이 없습니다.`;
